import Vue from 'vue'
import i18n from '@/i18n'
import App from './App.vue'
import router from './router'
import store from '@/store'
import 'current-script-polyfill'
import 'aixue-ui/dist/aixue-ui.css'
import aixueUi from 'aixue-ui'
import Imager from './components/Imager.vue'
import '@/styles/_common.scss'
import '@/styles/fonts/iconfont.css'
import '@/styles/fonts/iconfont.js'
import 'swiper/css/swiper.min.css'
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition'

Vue.use(aixueUi)

Vue.component('Imager', Imager)
Vue.component(CollapseTransition.name, CollapseTransition)
Vue.prototype.$toast = aixueUi.Toast
Vue.prototype.defaultCover = process.env.VUE_APP_DEFAULT_COVER
Vue.directive('focus', {
  inserted: function (el) {
    el.focus()
  }
})

Vue.config.productionTip = false

new Vue(Vue.util.extend({
  router,
  store,
  i18n,
  mounted () {
    // document.dispatchEvent(new Event('render-event'))
  }
}, App)).$mount('#app')
